module.exports = __webpack_public_path__ + "img/stephane-bourez-forest-discovery.a8f6ffb.jpg";